(function(EF, undefined) {

  // # EF.Models.Group
  //
  // Group is the level model above modules with modules inside them.  This model
  // provides an interface for retrieving data about a group and its modules.
  var Group = Chaplin.Model.extend({

    initialize: function(attrs, options) {
      options = options || {};
      this.currentModule = null;

      _.bindAll(this, 'attachCompletionEvents');

      this.initModules(attrs.modules || []);
    },

    defaults: {
      completed: false,
      status: 'incomplete'
    },

    initModules: function(modules, options) {
      this.set('modules', new EF.Collections.ModulesCollection(modules, options));
      this.modules = this.get('modules');
    },

    attachCompletionEvents: function() {
      var self = this;

      this.set('completed', this.isComplete());

      this.on('change:completed', function() {
        if(self.get('completed')) {
          self.set('status', 'complete');
        }
      });
    },

    getStartingModule: function() {
      var firstNotComplete = this.modules.find(function(module) {
        return !module.isComplete();
      });

      if(firstNotComplete) {
        this.currentModule = firstNotComplete;
        return firstNotComplete;
      }
      else {
        this.currentModule = null;
        return false;
      }
    },

    isComplete: function() {
      return this.modules.every(function(module) {
        return module.isComplete();
      });
    }

  });

_.extend(EF.Models, {
  Group: Group
});

})(EF);
